const HIGIM2Exclusions = {
  HIPlanExclMentalOrNervous: 'Mental/Nervous',
  HIPlanExclAlcoholism: 'Alcoholism, drug addiction or substance dependency (dependent/habitual)',
  HIPlanExclInjOrSickPriorToCoverageEffectiveDate: 'Injury or sickness prior to coverage effective date',
  HIPlanExclParticipationInAeronautics: 'Participation in any form of aeronautics',
  HIPlanExclNewbornCare: 'Newborn well baby care during initial hospital confinement',
  HIPlanExclDrivingMotorizedVehicle: 'Driving a motorized vehicle in a race or speed test',
  HIPlanExclIntoxicantNarcoticHallucinogenAlcohol:
    'Intoxicants, narcotics, hallucinogens or under influence of alcohol (one-time use)',
  HIPlanExclWarOrActOfWar: 'War or act of war',
  HIPlanExclFelonyOrAssaultOrIllegalOccupation: 'Felony or assault / illegal occupation',
  HIPlanExclSuicide: 'Suicide',
  HIPlanExclCosmeticDentalOrPlasticSurgery: 'Cosmetic Dental or plastic surgery',
  HIPlanExclIntentionallySelfInflictedInjuries: 'Intentionally self-inflicted injuries',
  HIPlanExclConfinementBeforeEffDateOfCov: 'Confinement before effective date of coverage',
  HIPlanExclReversalOfATubalLigationOrVasectomy: 'Reversal of a tubal ligation or vasectomy',
  HIPlanExclArtificialInsemination: 'Artificial insemination, in vitro fertilization, and test tube fertilization',
  HIPlanExclTreatmentRenderedByPersonOrFamily: 'Treatment rendered by you, your spouse, children, parents, or siblings',
  HIPlanExclTreatmentOutsideOfUnitedStates: 'Treatment outside of the United States or its territories',
};

export const benefitOptions: Record<string, Object> = {
  gpluAccelDeathExclusions: {
    hasMentalOrEmotionalDisorder: 'Mental or emotional disorder',
    hasAlcoholOrDrugAddiction: "Alcoholism or drug addiction",
    isWarIllness: "Illness, treatment, medical condition due to war, felony, armed forces service",
    isSuicideOrSelfInflictedInjury: "Sucide or intentionally self-inflicted injury",
    isServicePayableUnderGovtProgram: "Services payable under Medicare or another governmental program (except Medicaid)",
    isCoveredUnderWorkersCompOrNoFaultLaw: "State or federal workers' compensation, employer's liability or occupational disease law, or any motor vehicle no-fault law",
    isForeignTreatment: "Treatment outside of the United States or its territories",
  },
  automobileAccidentRiderDetails: {
    isAccidentFacilityCareApplied: 'Accident Facility Care',
    isAccidentInjuriesApplied: 'Accident Injuries',
    isAccidentTreatmentUrgentCareApplied: 'Accident Treatment and Urgent Care',
    isDislocationFractureRiderApplied: 'Dislocation and Fracture Rider',
    isTreatmentSupportRecoveryApplied: 'Treatment, Support, and Recovery',
  },
  organizedSportsActivityInjuryRiderDetails: {
    isAccidentFacilityCareApplied: 'Accident Facility Care',
    isAccidentInjuriesApplied: 'Accident Injuries',
    isAccidentTreatmentUrgentCareApplied: 'Accident Treatment and Urgent Care',
    isDislocationFractureRiderApplied: 'Dislocation and Fracture Rider',
    isTreatmentSupportRecoveryApplied: 'Treatment, Support, and Recovery',
  },
  groupPolicyFacilityRiderDetails: {
    isAccidentFacilityCareApplied: 'Accident Facility Care',
    isAccidentInjuriesApplied: 'Accident Injuries',
    isAccidentTreatmentUrgentCareApplied: 'Accident Treatment and Urgent Care',
    isDislocationFractureRiderApplied: 'Dislocation and Fracture Rider',
    isTreatmentSupportRecoveryApplied: 'Treatment, Support, and Recovery',
  },
  childhoodConditionsDetails: {
    isCerebralPalsy: 'Cerebral Palsy',
    isCleftLipOrPalate: 'Cleft Lip/Palate',
    isCongenitalHeartDisease: 'Congenital Heart Disease',
    isCysticFibrosis: 'Cystic Fibrosis',
    isDownSyndrome: 'Down Syndrome',
    isMuscularDystrophy: 'Muscular Dystrophy',
    isSpinaBifida: 'Spina Bifida',
    isStructuralCongenitalDefect: 'Structural Congenital Defect',
    isTypeOneDiabetes: 'Type 1 Diabetes',
  },
  skinCancerRider: {
    isBasalCellCarcinoma: 'Basal Cell Carcinoma',
    isSquamousCellCarcinomaOfTheSkin: 'Squamous Cell Carcinoma Of The Skin',
  },
  specConditionAndInfDiseaseDetails: {
    isAdrenalInsufficiency: 'Adrenal Insufficiency (Addison’s Disease)',
    isAmyotrophicLateralSclerosis: 'Amyotrophic Lateral Sclerosis (ALS or Lou Gehrig’s Disease)',
    isBacterialMeningitis: 'Bacterial Meningitis',
    isCerebralPalsy: 'Cerebral Palsy',
    isCysticFibrosis: 'Cystic Fibrosis',
    isDiphtheria: 'Diphtheria',
    isEncephalitis: 'Encephalitis',
    isHuntingtonChorea: 'Huntington’s Chorea',
    isLegionnaireDisease: 'Legionnaire’s Disease',
    isMalaria: 'Malaria',
    isMultipleSclerosis: 'Multiple Sclerosis',
    isMuscularDystrophy: 'Muscular Dystrophy',
    isMyastheniaGravis: 'Myasthenia Gravis',
    isNecrotizingFasciitis: 'Necrotizing Fasciitis',
    isOsteomyelitis: 'Osteomyelitis',
    isPoliomyelitis: 'Poliomyelitis',
    isRabies: 'Rabies',
    isScleroderma: 'Scleroderma',
    isSickleCellAnemia: 'Sickle Cell Anemia',
    isSystemicLupus: 'Systemic Lupus',
    isTetanus: 'Tetanus',
    isTuberculosis: 'Tuberculosis',
    isAcuteRespiratoryDistressSyndrome: 'Acute Respiratory Distress Syndrome (ARDS)',
    isNovelInfectiousDisease: 'Novel Infectious Disease',
  },
  specConditionAndInfDiseaseDetailsGVCI4: {
    isAdrenalInsufficiency: 'Adrenal Insufficiency (Addison’s Disease)',
    isAmyotrophicLateralSclerosis: 'Amyotrophic Lateral Sclerosis (ALS or Lou Gehrig’s Disease)',
    isBacterialMeningitis: 'Bacterial Meningitis',
    isCerebralPalsy: 'Cerebral Palsy',
    isCysticFibrosis: 'Cystic Fibrosis',
    isDiphtheria: 'Diphtheria',
    isEncephalitis: 'Encephalitis',
    isHuntingtonChorea: 'Huntington’s Chorea',
    isLegionnaireDisease: 'Legionnaire’s Disease',
    isMalaria: 'Malaria',
    isMultipleSclerosis: 'Multiple Sclerosis',
    isMuscularDystrophy: 'Muscular Dystrophy',
    isMyastheniaGravis: 'Myasthenia Gravis',
    isNecrotizingFasciitis: 'Necrotizing Fasciitis',
    isOsteomyelitis: 'Osteomyelitis',
    isPoliomyelitis: 'Poliomyelitis',
    isRabies: 'Rabies',
    isScleroderma: 'Scleroderma',
    isSickleCellAnemia: 'Sickle Cell Anemia',
    isSystemicLupus: 'Systemic Lupus',
    isTetanus: 'Tetanus',
    isTuberculosis: 'Tuberculosis',
  },
  specifiedChronicIllnessRider: {
    isAdrenalInsufficiency: 'Adrenal Insufficiency (Addison’s Disease)',
    isAmyotrophicLateralSclerosis: 'Amyotrophic Lateral Sclerosis (ALS or Lou Gehrig’s Disease)',
    isArthritis: 'Arthritis',
    isHuntingtonsChorea: 'Huntington’s Chorea',
    isMultipleSclerosis: 'Multiple Sclerosis',
    isSCIMuscularDystrophy: 'Muscular Dystrophy',
    isOsteomyelitis: 'Osteomyelitis',
    isOsteoporosis: 'Osteoporosis',
  },
  specifiedChronicIllnessAndAccidentalInjuryRider: {
    isAdrenalInsufficiency: 'Adrenal Insufficiency (Addison’s Disease)',
    isAmyotrophicLateralSclerosis: 'Amyotrophic Lateral Sclerosis (ALS or Lou Gehrig’s Disease)',
    isArthritis: 'Arthritis',
    isHuntingtonsChorea: 'Huntington’s Chorea',
    isMultipleSclerosis: 'Multiple Sclerosis',
    isSCIMuscularDystrophy: 'Muscular Dystrophy',
    isOsteomyelitis: 'Osteomyelitis',
    isOsteoporosis: 'Osteoporosis',
  },
  automobileAccidentRiderDetailsGHI3: {
    isHospitalCareServicesApplied: 'Hospital Care Services',
    isAdditionalCareServicesApplied: 'Additional Care Services',
  },
  groupPolicyHolderDetails: {
    isHospitalCareServicesApplied: 'Hospital Care Services',
    isAdditionalCareServicesApplied: 'Additional Care Services',
    isBehavioralHealthServicesApplied: 'Behavioral Health Services',
  },
  healthScreeningDetailsExclusions: {
    isExclusionMentalNervous: 'Mental/Nervous',
    isExclusionSubstanceabuse: 'Substance abuse',
    isExclusionParticipationInRiotInsurrectionOrRebellion: 'Participation in a riot, insurrection or rebellion',
    isExclusionParticipationInAeronautics: 'Participation in any form of aeronautics',
    isExclusionVoluntaryTakingOfAnypoison: 'Voluntary taking of any poison',
    isExclusionDrivingMotorizedVehicleInRaceorSpeedtest: 'Driving a motorized vehicle in a race or speed test',
    isExclusionOperatingavehiclewithabloodalcohollevel:
      'Operating a vehicle with a blood alcohol level that exceeds legal limit',
    isExclusionAnyactofwarwhetherornotdeclared: 'Any act of war, whether or not declared',
    isExclusionFelonyorassaultOrillegaloccupation: 'Felony or assault / illegal occupation',
    isExclusionSuicide: 'Suicide',
    isExclusionCosmeticDentalorplasticsurgery: 'Cosmetic Dental or plastic surgery',
    isExclusionIntentionallyselfInflictedinjuries: 'Intentionally self-inflicted injuries',
    isExclusionConfinementbeforeeffectivedateofcoverage: 'Confinement before effective date of coverage',
    isExclusionReversalofatuballigationorvasectomy: 'Reversal of a tubal ligation or vasectomy',
    isExclusionArtificialinsemination: 'Artificial insemination, in vitro fertilization, and test tube fertilization',
    isExclusionVoluntarytakingofanydrugorsedative: 'Voluntary taking of any drug or sedative',
    isExclusionTreatmentoutsideoftheUnitedStatesoritsterritories:
      'Treatment outside of the United States or its territories',
    isExclusionPreExistingConditions: 'Pre-Existing Conditions',
  },
  healthScreeningDetailsFixedBenefit: {
    CiHsbOptionColonoscopy: 'Colonoscopy',
    CiHsbOptionSerumProteinElectrophoresis: 'Serum Protein Electrophoresis',
    CiHsbOptionFastingPlasmaGlucoseTest: 'Fasting Plasma Glucose Test',
    CiHsbOptionFastingBloodGlucoseTest: 'Fasting Blood Glucose Test',
    CiHsbOptionTestingForDonationOfBoneMarrow: 'Testing For Donation Of Bone Marrow, including HLA',
    CiHsbOptionCarcinoembryonicAntigenBloodTest: 'Carcinoembryonic Antigen Blood Test (CEA)',
    CiHsbOptionHemoglobinA1C: 'Hemoglobin A1C',
    CiHsbOptionStressTestOnBikeorTreadmill: 'Stress Test On Bike or Treadmill',
    CiHsbOptionLipidPanelCholesterolCount: 'Lipid Panel Cholesterol Count',
    CiHsbOptionDopplerScreeningForCancer: 'Doppler Screening For Cancer',
    CiHsbOptionProstateDashSpecificAntigenTest: 'Prostate-Specific Antigen (PSA) Test',
    CiHsbOptionBloodTestForTriglycerides: 'Blood Test For Triglycerides',
    CiHsbOptionClinicalTesticularExam: 'Clinical Testicular Exam',
    CiHsbOptionFlexibleSigmoidoscopy: 'Flexible Sigmoidoscopy',
    CiHsbOptionSkinExam: 'Skin Exam',
    CiHsbOptionPapSmear: 'Pap Smear, including Thin Prep Pap Test',
    CiHsbOptionDopplerScreeningForCarotids: 'Doppler Screening For Carotids',
    CiHsbOptionElectrocardiogram: 'Electrocardiogram (EKG)',
    CiHsbOptionOtherBenefits: 'Other',
    CiHsbOptionChestXRay: 'Chest X-Ray',
    CiHsbOptionCompleteBloodCount: 'Complete Blood Count (CBC)',
    CiHsbOptionBloodChemistryPanel: 'Blood Chemistry Panel',
    CiHsbOptionTwoDashHourPostDashLoadPlasmaGlucoseTest: 'Two-Hour Post-Load Plasma Glucose Test',
    CiHsbOptionNovelInfectiousImmunization: 'Novel Infectious Immunization',
    CiHsbOptionEndoscopy: 'Endoscopy',
    CiHsbOptionUltrasoundForCancerDetection: 'Ultrasound For Cancer Detection',
    CiHsbOptionEchocardiogram: 'Echocardiogram',
    CiHsbOptionBiopsyForCancer: 'Biopsy For Cancer',
    CiHsbOptionThermography: 'Thermography',
    CiHsbOptionElectroencephalogram: 'Electroencephalogram (EEG)',
    CiHsbOptionBloodOrTissueTestingForGeneticSusceptibilityOfCancer:
      'Blood Or Tissue Testing For Genetic Susceptibility Of Cancer',
    CiHsbOptionBiopsyForSkinCancer: 'Biopsy For Skin Cancer',
    CiHsbOptionHemoccultStoolAnalysis: 'Hemoccult Stool Analysis',
    CiHsbOptionHumanPapillomavirusVaccination: 'Human Papillomavirus (HPV) Vaccination',
    CiHsbOptionUltrasoundOfAbdominalAortaForAorticAneurysms: 'Ultrasound Of Abdominal Aorta For Aortic Aneurysms',
    CiHsbOptionNovelInfectiousDiseaseTesting: 'Novel Infectious Disease Testing',
    CiHsbOptionCancerAntigen125BloodTest: 'Cancer Antigen 125 Blood Test',
    CiHsbOptionDopplerScreeningForPeripheralVascularDisease: 'Doppler Screening For Peripheral Vascular Disease',
    CiHsbOptionSkinCancerScreening: 'Skin Cancer Screening',
    CiHsbOptionMammography: 'Mammography, including Breast Ultrasound',
    CiHsbOptionCancerAntigen15Dash3BloodTest: 'Cancer Antigen 15-3 Blood Test',
    CiHsbOptionOralCancerScreening: 'Oral Cancer Screening',
  },
  healthScreeningDetailsVariableCategory0: {
    isOptionsAppliedBloodChemistryPanel: 'Blood Chemistry Panel',
    isOptionsAppliedBloodTestForTriglycerides: 'Blood Test For Triglycerides',
    isOptionsAppliedCancerAntigen125BloodTest: 'Cancer Antigen 125 Blood Test',
    isOptionsAppliedCancerAntigen153BloodTest: 'Cancer Antigen 15-3 Blood Test',
    isOptionsAppliedCarcinoembryonicAntigenBloodTest: 'Carcinoembryonic Antigen Blood Test (CEA)',
    isOptionsAppliedClinicalTesticularExam: 'Clinical Testicular Exam',
    isOptionsAppliedCompleteBloodCount: 'Complete Blood Count (CBC)',
    isOptionsAppliedFastingBloodGlucoseTest: 'Fasting Blood Glucose Test',
    isOptionsAppliedFastingPlasmaGlucoseTest: 'Fasting Plasma Glucose Test',
    isOptionsAppliedHemoccultStoolAnalysis: 'Hemoccult Stool Analysis',
    isOptionsAppliedHemoglobinA1C: 'Hemoglobin A1C',
    isOptionsAppliedHPVVaccination: 'Human Papillomavirus (HPV) Vaccination',
    isOptionsAppliedLipidPanelCholesterolCount: 'Lipid Panel Cholesterol Count',
    isOptionsAppliedOralCancerScreening: 'Oral Cancer Screening',
    isOptionsAppliedPapSmearPrepPapTest: 'Pap Smear, including Thin Prep Pap Test',
    isOptionsAppliedPSATest: 'Prostate-Specific Antigen (PSA) Test',
    isOptionsAppliedSerumProteinElectrophoresis: 'Serum Protein Electrophoresis',
    isOptionsAppliedSkinCancerScreening: 'Skin Cancer Screening',
    isOptionsAppliedSkinExam: 'Skin Exam',
    isOptionsAppliedTestingForDonationOfBoneMarrow: 'Testing For Donation Of Bone Marrow, including HLA',
    isOptionsAppliedTwoHourPostLoadPlasmaGlucoseTest: 'Two-Hour Post-Load Plasma Glucose Test',
    isOptionsAppliedNovelInfectiousDiseaseTesting: 'Novel Infectious Disease Testing',
    isOptionsAppliedNovelInfectiousImmunization: 'Novel Infectious Immunization',
    isOptionsAppliedOther: 'Other',
  },
  healthScreeningDetailsVariableCategory1: {
    isOptionsAppliedBiopsyForCancer: 'Biopsy for cancer',
    isOptionsAppliedBiopsyForSkinCancer: 'Biopsy for skin cancer',
    isOptionsAppliedBloodOrTissueTesting: 'Blood Or Tissue Testing For Genetic Susceptibility Of Cancer',
    isOptionsAppliedChestXRay: 'Chest X-Ray',
    isOptionsAppliedDopplerScreeningForCancer: 'Doppler Screening For Cancer',
    isOptionsAppliedDopplerScreeningForCarotids: 'Doppler Screening For Carotids',
    isOptionsAppliedDopplerScreeningForPVD: 'Doppler Screening For Peripheral Vascular Disease',
    isOptionsAppliedEchocardiogram: 'Echocardiogram',
    isOptionsAppliedElectrocardiogram: 'Electrocardiogram (EKG)',
    isOptionsAppliedElectroencephalogram: 'Electroencephalogram (EEG)',
    isOptionsAppliedEndoscopy: 'Endoscopy',
    isOptionsAppliedMammography: 'Mammography, including Breast Ultrasound',
    isOptionsAppliedStressTestOnBikeorTreadmill: 'Stress Test On Bike or Treadmill',
    isOptionsAppliedThermography: 'Thermography',
    isOptionsAppliedUltrasoundForCancerDetection: 'Ultrasound For Cancer Detection',
  },
  healthScreeningDetailsVariableCategory2: {
    isOptionsAppliedColonoscopy: 'Colonoscopy',
    isOptionsAppliedFlexibleSigmoidoscopy: 'Flexible Sigmoidoscopy',
    isOptionsAppliedUltrasound: 'Ultrasound Of Abdominal Aorta For Aortic Aneurysms',
  },
  healthScreeningDetailsGVCI4FixedBenefit: {
    CiHsbOptionBiopsyForSkinCancer: 'Biopsy For Skin Cancer',
    CiHsbOptionBloodOrTissueTestingForGeneticSusceptibilityOfCancer:
      'Blood Or Tissue Testing For Genetic Susceptibility Of Cancer',
    CiHsbOptionBloodTestForTriglycerides: 'Blood Test For Triglycerides',
    CiHsbOptionBownMarraowTesting: 'Bown Marrow Testing',
    CiHsbOptionCancerAntigen125BloodTest: 'Cancer Antigen 125 Blood Test',
    CiHsbOptionCancerAntigen15Dash3BloodTest: 'Cancer Antigen 15-3 Blood Test',
    CiHsbOptionCarcinoembryonicAntigenBloodTest: 'Carcinoembryonic Antigen Blood Test (CEA)',
    CiHsbOptionChestXRay: 'Chest X-Ray',
    CiHsbOptionColonoscopy: 'Colonoscopy',
    CiHsbOptionDopplerScreeningForCarotids: 'Doppler Screening For Carotids',
    CiHsbOptionDopplerScreeningForPeripheralVascularDisease: 'Doppler Screening For Peripheral Vascular Disease',
    CiHsbOptionEchocardiogram: 'Echocardiogram',
    CiHsbOptionElectrocardiogram: 'Electrocardiogram (EKG)',
    CiHsbOptionFlexibleSigmoidoscopy: 'Flexible Sigmoidoscopy',
    CiHsbOptionHemoccultStoolAnalysis: 'Hemoccult Stool Analysis',
    CiHsbOptionHumanPapillomavirusVaccination: 'Human Papillomavirus (HPV) Vaccination',
    CiHsbOptionLipidPanelCholesterolCount: 'Lipid Panel Cholesterol Count',
    CiHsbOptionMammography: 'Mammography, including Breast Ultrasound',
    CiHsbOptionAnyGenerallyMedicallyAcceptedCancerScreeningTestNotListedAbove:
      'Any generally medically accepted cancer screening test not listed above',
    CiHsbOptionPapSmear: 'Pap Smear, including Thin Prep Pap Test',
    CiHsbOptionProstateDashSpecificAntigenTest: 'Prostate-Specific Antigen (PSA) Test',
    CiHsbOptionSerumProteinElectrophoresis: 'Serum Protein Electrophoresis (test for myeloma)',
    CiHsbOptionStressTestOnBikeorTreadmill: 'Stress Test On Bike or Treadmill',
    CiHsbOptionThermography: 'Thermography',
    CiHsbOptionUltrasoundOfAbdominalAortaForAorticAneurysms: 'Ultrasound Of Abdominal Aorta For Aortic Aneurysms',
    CiHsbOptionOtherBenefits: 'Other',
  },
  healthScreeningDetailsGVCI4VariableCategory0: {
    isOptionsAppliedBloodTestForTriglycerides: 'Blood Test For Triglycerides',
    isOptionsAppliedCancerAntigen125BloodTest: 'Cancer Antigen 125 Blood Test',
    isOptionsAppliedCancerAntigen153BloodTest: 'Cancer Antigen 15-3 Blood Test',
    isOptionsAppliedCarcinoembryonicAntigenBloodTest: 'Carcinoembryonic Antigen Blood Test (CEA)',
    isOptionsAppliedHemoccultStoolAnalysis: 'Hemoccult Stool Analysis',
    isOptionsAppliedHPVVaccination: 'Human Papillomavirus (HPV) Vaccination',
    isOptionsAppliedLipidPanelCholesterolCount: 'Lipid Panel Cholesterol Count',
    isOptionAnyGenerallyMedicallyAcceptedCancerScreeningTestNotListedAbove:
      'Any generally medically accepted cancer screening test not listed above',
    isOptionsAppliedPapSmearPrepPapTest: 'Pap Smear, including Thin Prep Pap Test',
    isOptionsAppliedPSATest: 'Prostate-Specific Antigen (PSA) Test',
    isOptionSerumProteinElectrophoresis: 'Serum Protein Electrophoresis (test for myeloma)',
    isOptionsAppliedOther: 'Other',
  },
  healthScreeningDetailsGVCI4VariableCategory1: {
    isOptionsAppliedBiopsyForSkinCancer: 'Biopsy For Skin Cancer',
    isOptionsAppliedBloodOrTissueTesting: 'Blood Or Tissue Testing For Genetic Susceptibility Of Cancer',
    isOptionsAppliedChestXRay: 'Chest X-Ray',
    isOptionsAppliedDopplerScreeningForCarotids: 'Doppler Screening For Carotids',
    isOptionsAppliedDopplerScreeningForPVD: 'Doppler Screening For Peripheral Vascular Disease',
    isOptionsAppliedEchocardiogram: 'Echocardiogram',
    isOptionsAppliedElectrocardiogram: 'Electrocardiogram (EKG)',
    isOptionsAppliedMammography: 'Mammography, including Breast Ultrasound',
    isOptionsAppliedStressTestOnBikeorTreadmill: 'Stress Test On Bike or Treadmill',
    isOptionsAppliedThermography: 'Thermography',
  },
  healthScreeningDetailsGVCI4VariableCategory2: {
    isOptionsAppliedBoneMarrowTesting: 'Bone Marrow Testing',
    isOptionsAppliedColonoscopy: 'Colonoscopy',
    isOptionsAppliedFlexibleSigmoidoscopy: 'Flexible Sigmoidoscopy',
    isOptionsAppliedUltrasound: 'Ultrasound Of Abdominal Aorta For Aortic Aneurysms',
  },
  healthScreeningDetailsGVCI4WellnessandPreventiveCareBenefit: {
    CiHsbOptionBiopsyForSkinCancer: 'Biopsy For Skin Cancer',
    CiHsbOptionBloodOrTissueTestingForGeneticSusceptibilityOfCancer:
      'Blood Or Tissue Testing For Genetic Susceptibility Of Cancer',
    CiHsbOptionBloodTestForTriglycerides: 'Blood Test For Triglycerides',
    CiHsbOptionBownMarraowTesting: 'Bown Marrow Testing',
    CiHsbOptionCancerAntigen125BloodTest: 'Cancer Antigen 125 Blood Test',
    CiHsbOptionCancerAntigen15Dash3BloodTest: 'Cancer Antigen 15-3 Blood Test',
    CiHsbOptionCarcinoembryonicAntigenBloodTest: 'Carcinoembryonic Antigen Blood Test (CEA)',
    CiHsbOptionChestXRay: 'Chest X-Ray',
    CiHsbOptionColonoscopy: 'Colonoscopy',
    CiHsbOptionDopplerScreeningForCarotids: 'Doppler Screening For Carotids',
    CiHsbOptionDopplerScreeningForPeripheralVascularDisease: 'Doppler Screening For Peripheral Vascular Disease',
    CiHsbOptionEchocardiogram: 'Echocardiogram',
    CiHsbOptionElectrocardiogram: 'Electrocardiogram (EKG)',
    CiHsbOptionFlexibleSigmoidoscopy: 'Flexible Sigmoidoscopy',
    CiHsbOptionHemoccultStoolAnalysis: 'Hemoccult Stool Analysis',
    CiHsbOptionHumanPapillomavirusVaccination: 'Human Papillomavirus (HPV) Vaccination',
    CiHsbOptionImmunization: 'Immunization',
    CiHsbOptionInpatientVisitForRoutineNewbornCare: 'Inpatient Visit For Routine Newborn Care',
    CiHsbOptionLipidPanelCholesterolCount: 'Lipid Panel Cholesterol Count',
    CiHsbOptionMammography: 'Mammography, including Breast Ultrasound',
    CiHsbOptionAnyGenerallyMedicallyAcceptedCancerScreeningTestNotListedAbove:
      'Any generally medically accepted cancer screening test not listed above',
    CiHsbOptionInOfficeVisitsForPreventativeCare: 'In Office Visits For Preventative Care',
    CiHsbOptionPapSmearincludingThinPrepPapTest: 'Pap Smear, including Thin Prep Pap Test',
    CiHsbOptionProstateDashSpecificAntigenTest: 'Prostate-Specific Antigen (PSA) Test',
    CiHsbOptionSerumProteinElectrophoresis: 'Serum Protein Electrophoresis (test for myeloma)',
    CiHsbOptionStressTestOnBikeorTreadmill: 'Stress Test On Bike or Treadmill',
    CiHsbOptionThermography: 'Thermography',
    CiHsbOptionUltrasoundOfAbdominalAortaForAorticAneurysms: 'Ultrasound Of Abdominal Aorta For Aortic Aneurysms',
    CiHsbOptionOtherBenefits: 'Other',
  },
  healthScreeningDetailsWellnessCIExclusions: {
    CIExclHealthScreenBenefitIntentionallySelfInflictedInjury: 'Intentionally Self Inflicted Injury',
    CIExclHealthScreenBenefitAlcoholAbuse: 'Alcohol Abuse',
    CIExclHealthScreenBenefitDrugAbuse: 'Drug Abuse',
    CIExclHealthScreenBenefitDiagnosedBeforeEffectiveDate: 'Diagnosed Before Effective Date',
    CIExclHealthScreenBenefitIllegalActivitiesOrOccupation: 'Illegal activities or occupation',
    CIExclHealthScreenBenefitSuicide: 'Suicide',
    CIExclHealthScreenBenefitAppropriateHealthCareServices: 'Appropriate Health care services (MD Only)',
  },
  lifestyleEnhancementRider: {
    isTobaccoCessationProgram: 'Tobacco Cessation Program Of 8 Weeks Or Longer',
    isStressManagementProgram: 'Stress Management Program Of 12 Weeks Or Longer',
    isTimedEventRowing: 'Timed Event Rowing a Distance Of No Less Than 2 Kilometers',
    isTimedEventCombinationRunningRowingCyclingSwimming:
      'Timed Event a Combination Of Running, Rowing, Cycling, Or Swimming a Distance That Is No Less Than 20 Kilometers',
    isAlcoholCessationProgram: 'Alcohol Cessation Program Of 8 Weeks Or Longer',
    isGroupWalkingChallengeProgram: 'Group Walking Challenge Program Of 12 Weeks Or Longer',
    isTimedEventCycling: 'Timed Event Cycling a Distance Of No Less Than 20 Kilometers',
    isHealthManagementProgramWithOnlineHealthAssessment: 'Health Management Program With an Online Health Assessment',
    isWeightManagementProgram: 'Weight Management Program Of 12 Weeks Or Longer',
    isTimedEventRunning: 'Timed Event Running a Distance Of No Less Than 5 Kilometers',
    isTimedEventSwimming: 'Timed Event Swimming a Distance Of No Less Than 1 Kilometer',
    isFinancialWellnessProgram: 'Financial Wellness Program',
    isOtherEligiblePrograms: 'Other',
  },
  lifestyleEnhancementRiderGVCI4: {
    isTobaccoCessationProgram: 'Tobacco Cessation Program Of 8 Weeks Or Longer',
    isStressManagementProgram: 'Stress Management Program Of 12 Weeks Or Longer',
    isTimedEventRowing: 'Timed Event Rowing a Distance Of No Less Than 2 Kilometers',
    isTimedEventCombinationRunningRowingCyclingSwimming:
      'Timed Event a Combination Of Running, Rowing, Cycling, Or Swimming a Distance That Is No Less Than 20 Kilometers',
    isAlcoholCessationProgram: 'Alcohol Cessation Program Of 8 Weeks Or Longer',
    isGroupWalkingChallengeProgram: 'Group Walking Challenge Program Of 12 Weeks Or Longer',
    isTimedEventCycling: 'Timed Event Cycling a Distance Of No Less Than 20 Kilometers',
    isHealthManagementProgramWithOnlineHealthAssessment: 'Health Management Program With an Online Health Assessment',
    isWeightManagementProgram: 'Weight Management Program Of 12 Weeks Or Longer',
    isTimedEventRunning: 'Timed Event Running a Distance Of No Less Than 5 Kilometers',
    isTimedEventSwimming: 'Timed Event Swimming a Distance Of No Less Than 1 Kilometer',
    isOtherEligiblePrograms: 'Other',
  },
  healthScreeningDetailsVariableOptions: {
    optionsCategory0: '',
    optionsCategory1: '',
    optionsCategory2: '',
  },
  skinCancerRiderExclusions: {
    CISkinCancerRiderExclIntentionallySelfInflictedInjury: 'Intentionally Self Inflicted Injury',
    CISkinCancerRiderExclAlcoholAbuse: 'Alcohol Abuse',
    CISkinCancerRiderExclDrugAbuse: 'Drug Abuse',
    CISkinCancerRiderExclDiagnosedBeforeEffectiveDate: 'Diagnosed Before Effective Date',
    CISkinCancerRiderExclDiagnosedOutsideOfUSCanada: 'Diagnosed Outside of the U.S., U.S. Territories, or Canada',
    CISkinCancerRiderExclMalignantMelanoma: 'Malignant Melanoma',
    CISkinCancerRiderExclAnyConditionsConsideredPreCancerous: 'Any Conditions Considered Pre-Cancerous',
    CISkinCancerRiderExclPreExConditions: 'Pre-Existing Conditions',
  },
  skinCancerRiderGVCI4Exclusions: {
    CISkinCancerRiderExclIntentionallySelfInflictedInjury: 'Intentionally Self Inflicted Injury',
    CISkinCancerRiderExclAlcoholAbuse: 'Alcohol Abuse',
    CISkinCancerRiderExclDrugAbuse: 'Drug Abuse',
    CISkinCancerRiderExclDiagnosedBeforeEffectiveDate: 'Diagnosed Before Effective Date',
    CISkinCancerRiderExclSuicide: 'Suicide',
    CISkinCancerRiderExclAppropriateHealthCareServicesMDOnly: 'Appropriate Health care services (MD Only)',
    CISkinCancerRiderExclMalignantMelanoma: 'Malignant Melanoma',
    CISkinCancerRiderExclPreCancerousConditions: 'Pre-cancerous conditions',
    CISkinCancerRiderExclIllegalActivitiesOrOccupation: 'Illegal activities or occupation',
  },
  secondEvaluationTransportationAndLodgingRiderExclusions: {
    CIExclSecondEvaluationBenefitIntentionallySelfInflictedInjury: 'Intentionally Self Inflicted Injury',
    CIExclSecondEvaluationBenefitAlcoholAbuse: 'Alcohol Abuse',
    CIExclSecondEvaluationBenefitDrugAbuse: 'Drug Abuse',
    CIExclSecondEvaluationBenefitDiagnosedBeforeEffectiveDate: 'Diagnosed Before Effective Date',
    CIExclSecondEvaluationBenefitDiagnosedOutsideOfTheUS: 'Diagnosed Outside of the U.S., U.S. Territories, or Canada',
    CIExclSecondEvaluationBenefitPreExConditions: 'Pre-Existing Conditions',
  },
  secondEvaluationTransportationAndLodgingRiderGVCI4Exclusions: {
    CIExclSecondEvaluationBenefitIntentionallySelfInflictedInjury: 'Intentionally Self Inflicted Injury',
    CIExclSecondEvaluationBenefitAlcoholAbuse: 'Alcohol Abuse',
    CIExclSecondEvaluationBenefitDrugAbuse: 'Drug Abuse',
    CIExclSecondEvaluationBenefitDiagnosedBeforeEffectiveDate: 'Diagnosed Before Effective Date',
    CIExclSecondEvaluationBenefitIllegalActivitiesOccupation: 'Illegal activities or occupation',
    CIExclSecondEvaluationBenefiSuicide: 'Suicide',
    CIExclSecondEvaluationBenefitAppropriateHealth: 'Appropriate Health care services (MD Only)',
  },
  specConditionAndInfDiseaseDetailsExclusions: {
    CIExclSpecConditionAndInfDiseaseIntentionallySelfInflictedInjury: 'Intentionally Self Inflicted Injury',
    CIExclSpecConditionAndInfDiseaseAlcoholAbuse: 'Alcohol Abuse',
    CIExclSpecConditionAndInfDiseaseDrugAbuse: 'Drug Abuse',
    CIExclSpecConditionAndInfDiseaseDiagnosedBeforeEffectiveDate: 'Diagnosed Before Effective Date',
    CIExclSpecConditionAndInfDiseaseDiagnosedOutsideOfTheUS:
      'Diagnosed Outside of the U.S., U.S. Territories, or Canada',
    CIExclSpecConditionAndInfDiseasePreExCondition: 'Pre-Existing Conditions',
  },
  specConditionAndInfDiseaseDetailsGVCI4Exclusions: {
    CIExclSpecConditionAndInfDiseaseIntentionallySelfInflictedInjury: 'Intentionally Self Inflicted Injury',
    CIExclSpecConditionAndInfDiseaseAlcoholAbuse: 'Alcohol Abuse',
    CIExclSpecConditionAndInfDiseaseDrugAbuse: 'Drug Abuse',
    CIExclSpecConditionAndInfDiseaseDiagnosedBeforeEffectiveDate: 'Diagnosed Before Effective Date',
    CIExclSpecConditionAndInfDiseaseIllegalActOrOcc: 'Illegal activities or occupation',
    CIExclSpecConditionAndInfDiseaseSuicide: 'Suicide',
    CIExclSpecConditionAndInfDiseaseAddisonDisease:
      'Addison’s Disease does not include secondary and tertiary adrenal insufficiency',
    CIExclSpecConditionAndInfDiseaseSclerosisDiagnoses: 'Certain Multiple Sclerosis diagnoses',
    CIExclSpecConditionAndInfDiseaseSystemicLupus: 'Systemic Lupus does not include cases where only skin is affected',
    CIExclSpecConditionAndInfDiseaseAppropriateHealthCareServicesMDOnly: 'Appropriate Health care services (MD Only)',
    CIExclSpecConditionAndInfDiseaseBacterialMeningitis:
      'Bacterial Meningitis must include cases with pyogenic organism',
  },
  specifiedChronicIllnessRiderExclusions: {
    CIExclSCIBenefitIntentionallySelfInflictedInjury: 'Intentionally Self Inflicted Injury',
    CIExclSCIBenefitAlcoholAbuse: 'Alcohol Abuse',
    CIExclSCIBenefitDrugAbuse: 'Drug Abuse',
    CIExclSCIBenefitDiagnosedBeforeEffectiveDate: 'Diagnosed Before Effective Date',
    CIExclSCIBenefitDiagnosedOutsideOfTheUS: 'Diagnosed Outside of the U.S., U.S. Territories, or Canada',
    CIExclSCIBenefitPreExCondition: 'Pre-Existing Conditions',
  },
  specifiedChronicIllnessRiderGVCI4Exclusions: {
    CIExclSCIBenefitIntentionallySelfInflictedInjury: 'Intentionally Self Inflicted Injury',
    CIExclSCIBenefitAlcoholAbuse: 'Alcohol Abuse',
    CIExclSCIBenefitDrugAbuse: 'Drug Abuse',
    CIExclSCIBenefitDiagnosedBeforeEffectiveDate: 'Diagnosed Before Effective Date',
    CIExclSCIBenefitIllegalActivitiesOrOccupation: 'Illegal activities or occupation',
    CIExclSCIBenefitSuicide: 'Suicide',
    CIExclSCIBenefitAddisonDisease: 'Addison’s Disease does not include secondary and tertiary adrenal insufficiency',
    CIExclSCIBenefitCertainMultipleSclerosisDiagnoses: 'Certain Multiple Sclerosis diagnoses',
    CIExclSCIBenefitAppropriateHealthcareServicesMDOnly: 'Appropriate Health care services (MD Only)',
  },
  specifiedChronicIllnessAndAccidentalInjuryRiderExclusions: {
    CIExclSCIAndAIBenefitIntentionallySelfInflictedInjury: 'Intentionally Self Inflicted Injury',
    CIExclSCIAndAIBenefitAlcoholAbuse: 'Alcohol Abuse',
    CIExclSCIAndAIBenefitDrugAbuse: 'Drug Abuse',
    CIExclSCIAndAIBenefitDiagnosedBeforeEffectiveDate: 'Diagnosed Before Effective Date',
    CIExclSCIAndAIBenefitDiagnosedOutsideOfTheUS: 'Diagnosed Outside of the U.S., U.S. Territories, or Canada',
    CIExclSCIAndAIBenefitPreExCondition: 'Pre-Existing Conditions',
  },
  specifiedChronicIllnessAndAccidentalInjuryRiderGVCI4Exclusions: {
    CIExclSCIandAIBenefitIntentionallySelfInflictedInjury: 'Intentionally Self Inflicted Injury',
    CIExclSCIandAIBenefitAlcoholAbuse: 'Alcohol Abuse',
    CIExclSCIandAIBenefitDrugAbuse: 'Drug Abuse',
    CIExclSCIandAIBenefitDiagnosedBeforeEffectiveDate: 'Diagnosed Before Effective Date',
    CIExclSCIandAIBenefitIllegalActivitiesOrOccupation: 'Illegal activities or occupation',
    CIExclSCIandAIBenefitSuicide: 'Suicide',
    CIExclSCIandAIBenefitAddisonsDiseaseDoesNotIncludeSecondaryAndTertiaryAdrenalInsufficiency:
      'Addison’s Disease does not include secondary and tertiary adrenal insufficiency',
    CIExclSCIandAIBenefitCertainMultipleSclerosisDiagnoses: 'Certain Multiple Sclerosis diagnoses',
    CIExclSCIandAIBenefitAppropriateHealthCareServices: 'Appropriate Health care services (MD Only)',
  },
  healthScreeningDetailsCIExclusions: {
    CIExclHealthScreenBenefitIntentionallySelfInflictedInjury: 'Intentionally Self Inflicted Injury',
    CIExclHealthScreenBenefitAlcoholAbuse: 'Alcohol Abuse',
    CIExclHealthScreenBenefitDrugAbuse: 'Drug Abuse',
    CIExclHealthScreenBenefitDiagnosedBeforeEffectiveDate: 'Diagnosed Before Effective Date',
    CIExclHealthScreenBenefitDiagnosedOutsideOfTheUS: 'Diagnosed Outside of the U.S., U.S. Territories, or Canada',
    CIExclHealthScreenBenefitPreExCondition: 'Pre-Existing Conditions',
  },
  mentalNervousDisorderAndSubstanceAbuseRiderExclusions: {
    CIExclMentalBenefitIntentionallySelfInflictedInjury: 'Intentionally Self Inflicted Injury',
    CIExclMentalBenefitAlcoholAbuse: 'Alcohol Abuse',
    CIExclMentalBenefitDrugAbuse: 'Drug Abuse',
    CIExclMentalBenefitDiagnosedBeforeEffectiveDate: 'Diagnosed Before Effective Date',
    CIExclMentalBenefitDiagnosedOutsideOfTheUS: 'Diagnosed Outside of the U.S., U.S. Territories, or Canada',
    CIExclMentalBenefitPreExConditions: 'Pre-Existing Conditions',
  },
  lifestyleEnhancementRiderExclusions: {
    CIExclLifeStyleEnhancementBenefitIntentionallySelfInflictedInjury: 'Intentionally Self Inflicted Injury',
    CIExclLifeStyleEnhancementBenefitAlcoholAbuse: 'Alcohol Abuse',
    CIExclLifeStyleEnhancementBenefitDrugAbuse: 'Drug Abuse',
    CIExclLifeStyleEnhancementBenefitDiagnosedBeforeEffectiveDate: 'Diagnosed Before Effective Date',
    CIExclLifeStyleEnhancementBenefitDiagnosedOutsideoftheUS:
      'Diagnosed Outside of the U.S., U.S. Territories, or Canada',
    CIExclLifestyleEnhancementBenefitPreExConditions: 'Pre-Existing Conditions',
  },
  lifestyleEnhancementRiderGVCI4Exclusions: {
    CIExclLifeStyleEnhancementBenefitIntentionallySelfInflictedInjury: 'Intentionally Self Inflicted Injury',
    CIExclLifeStyleEnhancementBenefitAlcoholAbuse: 'Alcohol Abuse',
    CIExclLifeStyleEnhancementBenefitDrugAbuse: 'Drug Abuse',
    CIExclLifeStyleEnhancementBenefitDiagnosedBeforeEffectiveDate: 'Diagnosed Before Effective Date',
    CIExclLifeStyleEnhancementBenefitDiagnosedOutsideoftheUS:
      'Diagnosed Outside of the U.S., U.S. Territories, or Canada',
    CIExclLifeStyleEnhancementBenefitAppropriateHealthCareServicesMDOnly: 'Appropriate HealthCare Services(MD Only)',
    CIExclLifestyleEnhancementBenefitPreExConditions: 'Pre-Existing Conditions',
  },
  GCI5exclusions: {
    CIExclIntentionallySelfInflictedInjury: 'Intentionally Self Inflicted Injury',
    CIExclAlcoholAbuse: 'Alcohol Abuse',
    CIExclDrugAbuse: 'Drug Abuse',
    CIExclDiagnosedBeforeEffectiveDate: 'Diagnosed Before Effective Date',
    CIExclDiagnosedOutsideOfTheUS: 'Diagnosed Outside of the U.S., U.S. Territories, or Canada',
  },
  GVCI4exclusions: {
    CIExclIntentionallySelfInflictedInjury: 'Intentionally Self Inflicted Injury',
    CIExclAlcoholAbuse: 'Alcohol Abuse',
    CIExclDrugAbuse: 'Drug Abuse',
    CIExclDiagnosedBeforeEffectiveDate: 'Diagnosed Before Effective Date',
    CIExclSuicide: 'Suicide',
    CIExclIllegalActivitiesOrOccupation: 'Illegal activities or occupation',
    CIExclAppropriateHealthCareServicesMDOnly: 'Appropriate Health care services (MD Only)',
  },
  GIM2exclusions: HIGIM2Exclusions,
  GHI3exclusions: {
    HIPlanExclMentalOrNervous: 'Mental/Nervous',
    HIPlanExclSubstanceAbuse: 'Substance abuse',
    HIPlanExclParticipationInARiot: 'Participation in a riot, insurrection or rebellion',
    HIPlanExclParticipationInAeronautics: 'Participation in any form of aeronautics',
    HIPlanExclVoluntaryTakingPoison: 'Voluntary taking of any poison',
    HIPlanExclDrivingMotorizedVehicle: 'Driving a motorized vehicle in a race or speed test',
    HIPlanExclOperatingVehicleWithExceededAlcoholLevel:
      'Operating a vehicle with a blood alcohol level that exceeds legal limit',
    HIPlanExclActOfWarDeclaredOrNot: 'Any act of war, whether or not declared',
    HIPlanExclFelonyOrAssaultOrIllegalOccupation: 'Felony or assault / illegal occupation',
    HIPlanExclSuicide: 'Suicide',
    HIPlanExclCosmeticDentalOrPlasticSurgery: 'Cosmetic Dental or plastic surgery',
    HIPlanExclIntentionallySelfInflictedInjuries: 'Intentionally self-inflicted injuries',
    HIPlanExclConfinementBeforeEffDateOfCov: 'Confinement before effective date of coverage',
    HIPlanExclReversalOfATubalLigationOrVasectomy: 'Reversal of a tubal ligation or vasectomy',
    HIPlanExclArtificialInsemination: 'Artificial insemination, in vitro fertilization, and test tube fertilization',
    HIPlanExclVoluntaryTakingDrugOrSedative: 'Voluntary taking of any drug or sedative',
    HIPlanExclTreatmentOutsideOfUnitedStates: 'Treatment outside of the United States or its territories',
  },
  GAI7exclusions: {
    ACCExclAnyActOfWar: 'Any act of war, whether or not declared',
    ACCExclInfectionCausedByAnAccidentalCutOrWound: 'Infection that are not caused by an accidental cut or wound',
    ACCExclHernia: 'Hernia',
    ACCExclOnTheJobAccident: 'On the job accident',
    ACCExclParticipationInRiot: 'Participation in a riot',
    ACCExclAeronauticsWithException: 'Aeronautics, except as a fare-paying passenger',
    ACCExclOperatingVehicleWithExceededAlcoholLevel:
      'Operating a vehicle with a blood alcohol level that exceeds legal limit',
    ACCExclMedicalMalpractice: 'Medical malpractice',
    ACCExclSuicide: 'Suicide',
    ACCExclIllegalOccupationOrCommittingAnAssaultOrFelony: 'Illegal occupation or committing an assault or felony',
    ACCExclVoluntaryTakingOfAnyPoison: 'Voluntary taking of any poison',
    ACCExclElectiveSurgery: 'Elective surgery',
    ACCExclSelfInflictedInjuryOrAction: 'Self-inflicted injury or action',
    ACCExclOrganizedOrScheduledRaceOrSpeedTest: 'Organized or scheduled race or speed test',
    ACCExclVoluntaryTakingOfAnyDrugOrSedative: 'Voluntary taking of any drug or sedative',
    ACCExclPregnancy: 'Pregnancy',
    ACCExclWillfulCriminalActivity: 'Willful criminal activity (MI Only)',
  },
  GVA6exclusions: {
    ACCExclAnyActOfWar: 'Any act of war, whether or not declared',
    ACCExclInfectionCausedByAnAccidentalCutOrWound:
      'Bacterial infection that are not caused by an accidental cut or wound',
    ACCExclHernia: 'Hernia',
    ACCExclOnTheJobAccident: 'On the job accident',
    ACCExclParticipationInRiot: 'Participation in a riot, insurrection or rebellion',
    ACCExclAeronauticsWithException: 'Aeronautics, except as a fare-paying passenger',
    ACCExclInjuryWhileServingMilitaryNavalAirForce:
      'Injury while serving as an active member of military, naval, or air forces',
    ACCExclInjurySustainedWhileAlcoholDrugInfluenceUnlessPrescribed:
      'Injury sustained while under the influence of alcohol or any drug, unless as prescribed',
    ACCExclSuicide: 'Suicide, or any attempt at suicide, whether sane or insane',
    ACCExclIllegalOccupationOrCommittingAnAssaultOrFelony: 'Illegal occupation or committing an assault or felony',
    ACCExclSelfInflictedInjuryOrAction: 'Intentionally self-inflicted injury or action',
    ACCExclOrganizedOrScheduledRaceOrSpeedTest: 'Organized or scheduled race or speed test',
    ACCExclAppropriateHealthCare: 'Appropriate Health care services (MD Only)',
    // ACCExclWillfulCriminalActivity: 'Willful criminal activity (MI Only)'
  },
  Plan1exclusions: {
    isSuicide: 'Suicide',
  },

  outpatientPhysicianTreatmentsDetailsExclusions: {
    ACCExclAnyActOfWar: 'Any act of war, whether or not declared',
    ACCExclSuicide: 'Suicide, or any attempt at suicide, whether sane or insane',
    ACCExclSelfInflictedInjuryOrAction: 'Intentionally self-inflicted injury or action',
    ACCExclAeronauticsWithException: 'Aeronautics, except as a fare-paying passenger',
    ACCExclParticipationInRiot: 'Participation in a riot, insurrection or rebellion',
    ACCExclIllegalOccupationOrCommittingAnAssaultOrFelony: 'Illegal occupation or committing an assault or felony',
    ACCExclOrganizedOrScheduledRaceOrSpeedTest: 'Organized or scheduled race or speed test',
    ACCExclInjurySustainedWhileAlcoholDrugInfluenceUnlessPrescribed:
      'Injury sustained while under the influence of alcohol or any drug, unless as prescribed',
    ACCExclOnTheJobAccident: 'On the job accident',
    ACCExclInjuryWhileServingMilitaryNavalAirForce:
      'Injury while serving as an active member of military, naval, or air forces',
    ACCExclAppropriateHealthCare: 'Appropriate Health care services (MD Only)',
  },
  healthScreeningServicesRiderDetails: {
    isOptionsAppliedBiopsyForCancer: 'Biopsy For Cancer',
    isOptionsAppliedBiopsyForSkinCancer: 'Biopsy For Skin Cancer',
    isOptionsAppliedBloodChemistryPanel: 'Blood Chemistry Panel',
    isOptionsAppliedBloodOrTissueTestingForGSC: 'Blood Or Tissue Testing For Genetic Susceptibility Of Cancer',
    isOptionsAppliedBloodTestForTriglycerides: 'Blood Test For Triglycerides',
    isOptionsAppliedCancerAntigen125BloodTest: 'Cancer Antigen 125 Blood Test',
    isOptionsAppliedCancerAntigen153BloodTest: 'Cancer Antigen 15-3 Blood Test',
    isOptionsAppliedCarcinoembryonicAntigenBloodTest: 'Carcinoembryonic Antigen Blood Test (CEA)',
    isOptionsAppliedChestXRay: 'Chest X-Ray',
    isOptionsAppliedClinicalTesticularExam: 'Clinical Testicular Exam',
    isOptionsAppliedColonoscopy: 'Colonoscopy',
    isOptionsAppliedCompleteBloodCount: 'Complete Blood Count (CBC)',
    isOptionsAppliedDopplerScreeningForCancer: 'Doppler Screening For Cancer',
    isOptionsAppliedDopplerScreeningForCarotids: 'Doppler Screening For Carotids',
    isOptionsAppliedDopplerScreeningForPVD: 'Doppler Screening For Peripheral Vascular Disease',
    isOptionsAppliedEchocardiogram: 'Echocardiogram',
    isOptionsAppliedElectrocardiogram: 'Electrocardiogram (EKG)',
    isOptionsAppliedElectroencephalogram: 'Electroencephalogram (EEG)',
    isOptionsAppliedEndoscopy: 'Endoscopy',
    isOptionsAppliedFastingBloodGlucoseTest: 'Fasting Blood Glucose Test',
    isOptionsAppliedFastingPlasmaGlucoseTest: 'Fasting Plasma Glucose Test',
    isOptionsAppliedFlexibleSigmoidoscopy: 'Flexible Sigmoidoscopy',
    isOptionsAppliedHemoccultStoolAnalysis: 'Hemoccult Stool Analysis',
    isOptionsAppliedHemoglobinA1C: 'Hemoglobin A1C',
    isOptionsAppliedHumanPapillomavirus: 'Human Papillomavirus (HPV) Vaccination',
    isOptionsAppliedLipidPanelCholesterolCount: 'Lipid Panel Cholesterol Count',
    isOptionsAppliedMammographyincludingBreastUltrasound: 'Mammography, including Breast Ultrasound',
    isOptionsAppliedOralCancerScreening: 'Oral Cancer Screening',
    isOptionsAppliedPapSmearincludingThinPrepPapTest: 'Pap Smear, including Thin Prep Pap Test',
    isOptionsAppliedProstateSpecificAntigen: 'Prostate-Specific Antigen (PSA) Test',
    isOptionsAppliedSerumProteinElectrophoresis: 'Serum Protein Electrophoresis',
    isOptionsAppliedSkinCancerScreening: 'Skin Cancer Screening',
    isOptionsAppliedSkinExam: 'Skin Exam',
    isOptionsAppliedStressTestOnBikeorTreadmill: 'Stress Test On Bike or Treadmill',
    isOptionsAppliedTestingForDonationOfBoneMarrowincludingHLA: 'Testing For Donation Of Bone Marrow, including HLA',
    isOptionsAppliedThermography: 'Thermography',
    isOptionsAppliedTwoHourPostLoadPlasmaGlucoseTest: 'Two-Hour Post-Load Plasma Glucose Test',
    isOptionsAppliedUltrasoundForCancerDetection: 'Ultrasound For Cancer Detection',
    isOptionsAppliedUltrasoundOfAbdominalAortaForAorticAneurysms: 'Ultrasound Of Abdominal Aorta For Aortic Aneurysms',
    isOptionsAppliedNovelInfectiousDiseaseTesting: 'Novel Infectious Disease Testing',
    isOptionsAppliedNovelInfectiousImmunization: 'Novel Infectious Immunization',
    isOptionsAppliedOther: 'Other',
  },
};

export const healthScreeningServicesRiderDetails = {
  AccHsbOptionBiopsyForCancer: 'Biopsy For Cancer',
  AccHsbOptionBiopsyForSkinCancer: 'Biopsy For Skin Cancer',
  AccHsbOptionBloodChemistryPanel: 'Blood Chemistry Panel',
  AccHsbOptionBloodOrTissueTestingForGeneticSusceptibilityOfCancer:
    'Blood Or Tissue Testing For Genetic Susceptibility Of Cancer',
  AccHsbOptionBloodTestForTriglycerides: 'Blood Test For Triglycerides',
  AccHsbOptionCancerAntigen125BloodTest: 'Cancer Antigen 125 Blood Test',
  AccHsbOptionCancerAntigen15Dash3BloodTest: 'Cancer Antigen 15-3 Blood Test',
  AccHsbOptionCarcinoembryonicAntigenBloodTest: 'Carcinoembryonic Antigen Blood Test (CEA)',
  AccHsbOptionChestXRay: 'Chest X-Ray',
  AccHsbOptionClinicalTesticularExam: 'Clinical Testicular Exam',
  AccHsbOptionColonoscopy: 'Colonoscopy',
  AccHsbOptionCompleteBloodCount: 'Complete Blood Count (CBC)',
  AccHsbOptionDopplerScreeningForCancer: 'Doppler Screening For Cancer',
  AccHsbOptionDopplerScreeningForCarotids: 'Doppler Screening For Carotids',
  AccHsbOptionDopplerScreeningForPeripheralVascularDisease: 'Doppler Screening For Peripheral Vascular Disease',
  AccHsbOptionEchocardiogram: 'Echocardiogram',
  AccHsbOptionElectrocardiogram: 'Electrocardiogram (EKG)',
  AccHsbOptionElectroencephalogram: 'Electroencephalogram (EEG)',
  AccHsbOptionEndoscopy: 'Endoscopy',
  AccHsbOptionFastingBloodGlucoseTest: 'Fasting Blood Glucose Test',
  AccHsbOptionFastingPlasmaGlucoseTest: 'Fasting Plasma Glucose Test',
  AccHsbOptionFlexibleSigmoidoscopy: 'Flexible Sigmoidoscopy',
  AccHsbOptionHemoccultStoolAnalysis: 'Hemoccult Stool Analysis',
  AccHsbOptionHemoglobinA1C: 'Hemoglobin A1C',
  AccHsbOptionHumanPapillomavirusVaccination: 'Human Papillomavirus (HPV) Vaccination',
  AccHsbOptionLipidPanelCholesterolCount: 'Lipid Panel Cholesterol Count',
  AccHsbOptionMammography: 'Mammography, including Breast Ultrasound',
  AccHsbOptionOralCancerScreening: 'Oral Cancer Screening',
  AccHsbOptionPapSmear: 'Pap Smear, including Thin Prep Pap Test',
  AccHsbOptionProstateDashSpecificAntigenTest: 'Prostate-Specific Antigen (PSA) Test',
  AccHsbOptionSerumProteinElectrophoresis: 'Serum Protein Electrophoresis',
  AccHsbOptionSkinCancerScreening: 'Skin Cancer Screening',
  AccHsbOptionSkinExam: 'Skin Exam',
  AccHsbOptionStressTestOnBikeorTreadmill: 'Stress Test On Bike or Treadmill',
  AccHsbOptionTestingForDonationOfBoneMarrow: 'Testing For Donation Of Bone Marrow, including HLA',
  AccHsbOptionThermography: 'Thermography',
  AccHsbOptionTwoDashHourPostDashLoadPlasmaGlucoseTest: 'Two-Hour Post-Load Plasma Glucose Test',
  AccHsbOptionUltrasoundForCancerDetection: 'Ultrasound For Cancer Detection',
  AccHsbOptionUltrasoundOfAbdominalAortaForAorticAneurysms: 'Ultrasound Of Abdominal Aorta For Aortic Aneurysms',
  AccHsbOptionNovelInfectiousImmunization: 'Novel Infectious Immunization',
  AccHsbOptionNovelInfectiousDiseaseTesting: 'Novel Infectious Disease Testing',
  AccHsbOptionOtherBenefits: 'Other',
};

export const exclusionsMapping = {
  ACCExclAnyActOfWar: 'Any act of war, whether or not declared',
  ACCExclInfectionCausedByAnAccidentalCutOrWound: 'Infection that are not caused by an accidental cut or wound',
  ACCExclHernia: 'Hernia',
  ACCExclOnTheJobAccident: 'On the job accident',
  ACCExclParticipationInRiot: 'Participation in a riot',
  ACCExclAeronauticsWithException: 'Aeronautics, except as a fare-paying passenger',
  ACCExclOperatingVehicleWithExceededAlcoholLevel:
    'Operating a vehicle with a blood alcohol level that exceeds legal limit',
  ACCExclMedicalMalpractice: 'Medical malpractice',
  ACCExclSuicide: 'Suicide',
  ACCExclIllegalOccupationOrCommittingAnAssaultOrFelony: 'Illegal occupation or committing an assault or felony',
  ACCExclVoluntaryTakingOfAnyPoison: 'Voluntary taking of any poison',
  ACCExclElectiveSurgery: 'Elective surgery',
  ACCExclSelfInflictedInjuryOrAction: 'Self-inflicted injury or action',
  ACCExclOrganizedOrScheduledRaceOrSpeedTest: 'Organized or scheduled race or speed test',
  ACCExclVoluntaryTakingOfAnyDrugOrSedative: 'Voluntary taking of any drug or sedative',
  ACCExclPregnancy: 'Pregnancy',
  // ACCExclAppropriateHealthCare: 'Appropriate Health care services (MD Only)',
  //ACCExclWillfulCriminalActivity: 'Willful criminal activity (MI Only)',
};

export const parentPathExclusions = (plansIndex: number) => `benefitPackagingDetail.plans[${plansIndex}].exclusions`;
